import { datetime } from "rrule";

/**
 * Converts date to UTC.
 * @param date Date to convert.
 */
export function convertDateToUtc(date: Date): Date {
    return datetime(
        date.getFullYear(),
        date.getMonth() + 1,
        date.getDate(),
        date.getHours(),
        date.getMinutes(),
        date.getSeconds(),
    );
}
